if ($('.category-carousel__carousel').length > 0) {
  let initialSlide = 0;
  $(".category-carousel__item").each(function(index, el) {
    const isActive = $(this).hasClass("active");
    if(isActive) {
      initialSlide = index;
    }
  })
  $('.category-carousel__carousel').slick({
    infinite: false,
    dots: false,
    centerMode: false,
    centerPadding: '20px',
    slidesToShow: 6,
    slidesToScroll: 6,
    arrows: false,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          infinite: false,
          dots: true,
          centerMode: false,
          centerPadding: '20px',
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          appendDots: $('.category-carousel__dots'),
          prevArrow: $('.category-carousel__prev'),
          nextArrow: $('.category-carousel__next'),
          initialSlide: initialSlide,
        }
      },
      {
        breakpoint: 990,
        settings: {
          infinite: false,
          dots: true,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          appendDots: $('.category-carousel__dots'),
          prevArrow: $('.category-carousel__prev'),
          nextArrow: $('.category-carousel__next'),
          initialSlide: initialSlide,
        }
      }
    ]
  });
}